var map = {
	"./da-DK": [
		861,
		0,
		7
	],
	"./da-DK.ts": [
		861,
		0,
		7
	],
	"./de-DE": [
		862,
		0,
		8
	],
	"./de-DE.ts": [
		862,
		0,
		8
	],
	"./en-AU": [
		863,
		0,
		9
	],
	"./en-AU.ts": [
		863,
		0,
		9
	],
	"./en-GB": [
		864,
		0,
		10
	],
	"./en-GB.ts": [
		864,
		0,
		10
	],
	"./en-US": [
		865,
		0,
		11
	],
	"./en-US.ts": [
		865,
		0,
		11
	],
	"./es-ES": [
		866,
		0,
		12
	],
	"./es-ES.ts": [
		866,
		0,
		12
	],
	"./fr-FR": [
		867,
		0,
		13
	],
	"./fr-FR.ts": [
		867,
		0,
		13
	],
	"./it-IT": [
		868,
		0,
		14
	],
	"./it-IT.ts": [
		868,
		0,
		14
	],
	"./nb-NO": [
		869,
		0,
		15
	],
	"./nb-NO.ts": [
		869,
		0,
		15
	],
	"./nl-NL": [
		870,
		0,
		16
	],
	"./nl-NL.ts": [
		870,
		0,
		16
	],
	"./pl-PL": [
		871,
		0,
		17
	],
	"./pl-PL.ts": [
		871,
		0,
		17
	],
	"./pt-PT": [
		872,
		0,
		18
	],
	"./pt-PT.ts": [
		872,
		0,
		18
	],
	"./sv-SE": [
		873,
		0,
		19
	],
	"./sv-SE.ts": [
		873,
		0,
		19
	],
	"./tr-TR": [
		874,
		0,
		20
	],
	"./tr-TR.ts": [
		874,
		0,
		20
	]
};
function webpackAsyncContext(req) {
	if(!__webpack_require__.o(map, req)) {
		return Promise.resolve().then(function() {
			var e = new Error("Cannot find module '" + req + "'");
			e.code = 'MODULE_NOT_FOUND';
			throw e;
		});
	}

	var ids = map[req], id = ids[0];
	return Promise.all(ids.slice(1).map(__webpack_require__.e)).then(function() {
		return __webpack_require__(id);
	});
}
webpackAsyncContext.keys = function webpackAsyncContextKeys() {
	return Object.keys(map);
};
webpackAsyncContext.id = 1830;
module.exports = webpackAsyncContext;